import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse, HttpErrorResponse,
} from '@angular/common/http';
import { tap, finalize } from 'rxjs/operators';
import {LoadingService} from "../services/loader/loading.service";
import {Observable} from "rxjs";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private token: string | null = "";
  private activeRequests = 0;
  private static redirecting = false;


  constructor(private loadingService: LoadingService) {


  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.activeRequests === 0) {
       this.loadingService.show();
    }
    this.activeRequests++;
    if (localStorage.getItem('LoginData') != null ) {
      this.token = localStorage.getItem('LoginData');
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`
        }
      });
    }
    if (localStorage.getItem('currentYear') != null ) {
      request = request.clone({
        setHeaders: {
          'X-School-Year': localStorage.getItem('currentYear')!
        }
      })
    }
    if (localStorage.getItem('schoolCode') != null ) {
      request = request.clone({
        setHeaders: {
          'X-School-Code': localStorage.getItem('schoolCode')!
        }
      })
    }

    return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingService.hide();
          }
        }),
      tap((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          // Handle successful responses here
        }
      },
          (error: any) => {
        if (error instanceof HttpErrorResponse) {
          const isAuthRequest = error.url?.includes('/api/authenticate');
          if (error.status === 401 && !JwtInterceptor.redirecting && !isAuthRequest) {
            JwtInterceptor.redirecting = true;
            localStorage.removeItem('LoginData');
            localStorage.removeItem('CurrentUser');
            localStorage.removeItem('schoolCode');
            localStorage.removeItem('currentYear');
            window.location.href = '/login';
          }
          if (error.status === 500) {
            window.location.href = '/pages/under-maintenance';
          }
        }
      }));
  }
}
